angular.module('galilai.creator').controller('ImportController', function($scope, $rootScope, api, visual, parserService, $timeout) {

    // TODO - Hardcoded
    const BASE_SIZE = 350
    const SHOULD_CLEAN_SPAN_COLORS = false
    const INDEX_MAIN_ELEMENTS = 2
    const INDEX_BG = 1
    const UPDATE_CONTENT_INLINE = false
    const USE_VERTICAL_LINES = false
    $scope.features = {
        import_advanced: false,
    }

    $scope.stats = null
    $scope.classification = []
    $scope.objectivesMap = {}
    let classificationMap = {}
    let palletes = [
        {
            main: '#673ab7',
            text: '#ffffff',
            highlight: '#f519cd',
        },
    ]
    const VALID_STYLES = [
        'shape'
    ]
    const SAMPLE_PALETTES = [
        ["#002854", "#ffffff", "#d2b382"],
        ["#ffffff", "#0d83cf", "#40a9ed"],
        ["#fffaf8", "#100f0d", "#ff914d"],
        ["#073f89", "#ffffff", "#38b6ff"],
        ["#ffffff", "#023c6c", "#66ac4c"],
        ["#ffffff", "#120e11", "#c19a3a"],
        ["#ffffff", "#254656", "#d6ae33"],
        ["#ffffff", "#223342", "#ff914d"],
        ["#013c6a", "#ffffff", "#ff7401"],
        ["#ffffff", "#0a2449", "#fea106"],
        ["#ffffff", "#003264", "#43b0f1"],
        ["#000000", "#ffffff", "#ff964d"],
        ["#ffffff", "#202026", "#ff0000"],
        ["#ffffff", "#000000", "#fd8e49"],
        ["#282333", "#ffffff", "#ffde59"],
        ["#ffffff", "#000000", "#ffd015"],
        ["#050504", "#ffffff", "#ef3724"]
    ]

    $scope.vlinesColors = [
        '#ff0000',
        '#00ff00',
        '#0000ff',
        '#ffff00',
        '#ff00ff',
        '#00ffff',
    ]

    $scope.importTodo = [
        'Logo',
        //'Linhas verticais',
        'Diferentes tamanhos de posts',
        //'Identidade visual',
        'Fone e Endereço',
        'Categorias e Objetivo',
        //'Texto geração fixo vs dinâmico',
    ]

    SAMPLE_PALETTES.forEach(function(palette) {
        palletes.push({
            main: palette[0],
            text: palette[1],
            highlight: palette[2],
        })
    })

    function getRandomPallete() {
        let index = Math.floor(Math.random() * palletes.length)
        return palletes[index]
    }

    const textFields = [
        'title',
        'description',
        'address',
        'address_header',
        'phone',
        'website',
        'badge',
        'cta',
        'list_header',
        'list_item_1',
        'list_icon_1',
        'list_item_2',
        'list_icon_2',
        'list_item_3',
        'list_icon_3',
        'list_item_4',
        'list_icon_4',
    ]
    const slots = [
        'main',
        'logo',
        'footer',
        'header',
        'title',
        'description',
        'address',
        'phone',
        'website',
        'additional_1',
        'additional_2',
    ]
    const backgroundFields = textFields

    const imageFields = [
        'image',
        'person',
        'illustration',
        'image1',
        'image2',
        'image3',
        'image4',
    ].concat(textFields)

    let currentHash = new Date().getTime()
    let INITIAL_VIEW = {
        reviewing: false,
        colors: [],
        numberPages: 1,
        enabledFields: {},
        enabledGroups: [],
        editingLanguage: 'en',
        editingTemplate: false,
        currentSavedId: null,
        availableLanguages: [
            {
                value: 'en',
                name: window._LANGUAGES['en'],
            },
            {
                value: 'pt',
                name: window._LANGUAGES['pt'],
            }
        ],
        types: [
            {
                name: gettext('label.import_tabs_text'),
                value: 'text'
            },
            {
                name: gettext('label.import_tabs_image'),
                value: 'image'
            },
            {
                name: gettext('label.import_tabs_background'),
                value: 'background'
            },
            {
                name: 'Linhas verticais',
                value: 'vlines'
            },
            {
                name: 'Estrutura do texto',
                value: 'text-structure'
            },
            {
                name: 'Estrutura layout',
                value: 'layout-structure'
            },
        ],
        currentContent: {},
        postSize: 'portrait',
        selectedLayer: null,
        selectedType: 'text',
        currentLayers: [],
        mappingKinds: {},
        mappingRules: {},
        theme: BASE_THEME,
        mainBrandKit: null,
        availableValues: {
            fonts: [],
            colors: [],
        },
        currentMutatedContent: {},
        paintIds: [],
        repaintEnabled: false,
        vlinesEnabled: false,
        showVlines: false,
        vlines: {
            mapIds: {},
            rows: []
        },
        availableOptions: {
            'text': textFields.map(function(field) {
                return {
                    name: field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '),
                    value: field
                }
            }),
            'image': imageFields.map(function(field) {
                return {
                    name: field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '),
                    value: field
                }
            }),
            'background': backgroundFields.map(function(field) {
                return {
                    name: field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '),
                    value: field
                }
            }),
        },
        availableSlots: slots.map(function(field) {
            return {
                name: field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '),
                value: field
            }
        }),
    }

    INITIAL_VIEW.availableGroups = []
    INITIAL_VIEW.availableGroups = INITIAL_VIEW.availableGroups.concat(INITIAL_VIEW.availableOptions['text'])
    INITIAL_VIEW.availableGroups = INITIAL_VIEW.availableGroups.concat(INITIAL_VIEW.availableOptions['image'])


    function addPxIfNeeded(value) {
        if (value.toString().indexOf('px') === -1) {
            return value + 'px';
        }
        return value;
    }

    function getNextPaintId() {
        let mainElements = $scope.layout.tree.elements[INDEX_MAIN_ELEMENTS].elements
        let pId = 0
        if (mainElements && mainElements.length > 0) {
            mainElements.forEach(function(element) {
                if (element.pId && parseInt(element.pId) > pId) {
                    pId = parseInt(element.pId)
                }
            })
        }
        return (pId + 1).toString()
    }

    const SAMPLE_CONTENT = {
        title: '<em style="font-size:2rem;display:inline-block;font-weight:bold;line-height: normal;font-style:normal;color:#HIGHLIGHT" class="number-highlight">5</em> técnicas de produtividade para empreendedores',
        description: 'Outro texto grande',
        badge: 'Meus serviços',
        //image: 'https://images.pexels.com/photos/5200784/pexels-photo-5200784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
        author: {
            handle: '@logomarca.empresa',
        },
        address: 'Minha Rua, 986',
        phone: '99 99999-9999',
        cta: 'MEU CTA',
    }

    $scope.view = JSON.parse(JSON.stringify(INITIAL_VIEW))

    $scope.editingTemplateId = null
    $rootScope.$on('onUserData', function(event, args) {
        if (args.features && args.features.import_templates_advanced) {
            $scope.features.import_advanced = true
        }
        if (args.features && args.features.import_dynamic_templates) {
            $scope.features.import_dynamic_templates = true
        }
    })

    $rootScope.$on('openImport', function(event, data){
        $scope.cleanImport()
        if (data.projectId) {
            $scope.projectId = data.projectId
        }
        if (data.id) {
            $scope.view.editingTemplate = true
            $scope.editTemplate(data.id)
        }
        $scope.importAsStyle = !!data.style
        $scope.isDuplicate = !!data.duplicate
        $scope.getCategories()
    })

    $scope.layouts = []
    $scope.parsedPosts = []

    $scope.isAdvanced = function() {
        return $scope.features.import_advanced
    }

    $scope.isNormalUser = function() {
        return !$scope.features.import_advanced
    }

    $scope.isStyle = function() {
        return $scope.importAsStyle
    }

    $scope.selectType = function(type) {
        $scope.view.selectedType = type
        $scope.updateLayers()
    }

    $scope.isBrandKitTab = function() {
        return $scope.view.selectedType === 'colors' || $scope.view.selectedType === 'fonts'
    }

    $scope.shouldHideBrandKit = function(type) {
        if ($scope.isDynamicTemplateImporter() && (type.value == 'vlines' || type.value == 'text-structure' || type.value == 'layout-structure')) {
            return true
        }
        if ($scope.isStyle() && (type.value != 'colors' && type.value != 'fonts')) {
            return true
        }
        if (!$scope.view.pages) {
            return true
        }
        let active = $scope.view.pages.find(p => p.active)
        return (type.value === 'colors' || type.value === 'fonts') && $scope.view.pages && active && active.id > 0
    }

    function updateMapping() {
        // TODO - This is not needed anymore, remove
        let requiredMappingKinds = ['number']
        // Iterate over all elements and add key replace with value from mappingKinds (mapping kinds is id: type)
        let mappingKinds = $scope.view.mappingKinds
        function updateElements(tree) {
            for (let element of tree.elements) {
                if (mappingKinds[element.id]) {
                    element.replace = mappingKinds[element.id];
                    if (requiredMappingKinds.includes(mappingKinds[element.id])) {
                        element.required = true;
                    }
                } else if (element.value != '@logomarca') { // TODO - hardcoded
                    delete element.replace;
                    delete element.required;
                }
                if (element.elements) {
                    updateElements(element);
                }
            }
        }
        updateElements($scope.layout.tree);
    }
    $scope.onMappingChange = function(id, value) {
        const uniqueValues = [
            'main_image',
            //'title',
            'description',
        ]
        const defaultValues = {
            'text': 'fixed_text',
            'image': 'fixed_image',
        }
        if (uniqueValues.includes(value)) {
            // Then unset from other mappings and update id with value
            for (let key in $scope.view.mappingKinds) {
                if ($scope.view.mappingKinds[key] === value) {
                    $scope.view.mappingKinds[key] = defaultValues[$scope.view.selectedType]
                }
            }
        }
        $scope.view.mappingKinds[id] = value
        updateMapping()
    }

    function getBackgroundColors(elements, colors) {
        let backgrounds = elements.filter(e => e.type === 'rect')
        // Sort backgrounds by area
        backgrounds.sort(function(a, b) {
            return parseFloat(b.computed.width) * parseFloat(b.computed.height) - parseFloat(a.computed.width) * parseFloat(a.computed.height)
        })

        for (let background of backgrounds) {
            if (background.computed.background) {
                let color = background.computed.background.split(')')[0]
                let rgb = color.match(/\d+/g)
                if (rgb) {
                    let hex = RGBToHEX(...rgb)
                    if (!colors.includes(hex)) {
                        colors.push(hex)
                    }
                }
            }
        }
        return Array.from(new Set(colors))
    }
    function getTextColors(elements, colors) {
        let texts = elements.filter(e => e.type === 'p' || e.type === 'h1')
        // Sort backgrounds by area
        texts.sort(function(a, b) {
            return parseFloat(b.computed['font-size']) - parseFloat(a.computed['font-size'])
        })

        for (let text of texts) {
            if (text.computed.color) {
                let color = text.computed.color.split(')')[0]
                let rgb = color.match(/\d+/g)
                if (rgb) {
                    let hex = RGBToHEX(...rgb)
                    if (!colors.includes(hex)) {
                        colors.push(hex)
                    }
                }
            }
        }
        return Array.from(new Set(colors))
    }

    function getSVGColors(elements, colors) {
        let svgs = elements.filter(e => e.type === 'image' && e.content && e.content.includes('<svg') || e.type === 'svg')
        let foundColors = []
        for (let svg of svgs) {
            let parser = new DOMParser()
            let doc = parser.parseFromString(svg.content, 'image/svg+xml')
            let paths = doc.querySelectorAll('path')
            for (let path of paths) {
                if (path.getAttribute('fill')) {
                    foundColors.push(path.getAttribute('fill'))
                }
                if (path.getAttribute('stroke')) {
                    foundColors.push(path.getAttribute('stroke'))
                }
                // also read from style
                if (path.style.fill) {
                    foundColors.push(path.style.fill)
                }
                if (path.style.stroke) {
                    foundColors.push(path.style.stroke)
                }
            }
            // All query for <stop> elements
            let stops = doc.querySelectorAll('stop')
            for (let stop of stops) {
                if (stop.getAttribute('stop-color')) {
                    foundColors.push(stop.getAttribute('stop-color'))
                }
                if (stop.style['stop-color']) {
                    foundColors.push(stop.style['stop-color'])
                }
            }
            // Also read from style computed
            if (svg.computed.fill) {
                foundColors.push(svg.computed.fill)
            }
            if (svg.computed.stroke) {
                foundColors.push(svg.computed.stroke)
            }
        }
        // Remove duplicates
        foundColors = Array.from(new Set(foundColors))
        // Convert to HEX
        foundColors = foundColors.map(color => {
            if (color.indexOf('#') === 0) {
                return color
            }
            let rgb = color.match(/\d+/g)
            if (rgb) {
                return RGBToHEX(...rgb)
            }
            return null
        }).filter(color => color)

        // Add to colors only if not already there
        for (let color of foundColors) {
            if (!colors.includes(color)) {
                colors.push(color)
            }
        }
        return colors
    }

    $scope.updateLayers = function() {
        // Iterate recursevely trhough scope.layout.tree and get all nodes of type $scope.view.selectedType
        let layers = []
        let type = $scope.view.selectedType
        if (!type) {
            return
        }
        // TODO - Refactor
        let tree = $scope.layout.tree
        let mapTypes = {
            'text': ['p', 'h1'],
            'image': ['image'],
            'background': ['rect', 'svg'],
            'fonts': ['p', 'h1'],
            'colors': ['rect', 'p', 'h1', 'image', 'svg'],
        }
        let backgrounds = []
        let paintIds = [
            null,
            'main_bg'
        ]
        function getLayers(tree, type) {
            for (let element of tree.elements) {
                if (element.pId) {
                    paintIds.push(element.pId)
                }
                if (element.type == 'image' && element.content && type == 'background') {
                    layers.push(element)
                }
                if (mapTypes[type].includes(element.type)) {
                    if (element.type == 'image' && element.content && type != 'background') {
                        // Skip
                    }
                    else if (element.type === 'p' || element.type === 'h1') {
                        if (element.value) {
                            let value = element.value
                            // Clean values
                            if (SHOULD_CLEAN_SPAN_COLORS) {
                                value = value.replace(/color: rgb\([^)]+\)/g, '')
                                if (value.indexOf('style=""') > -1 || value.indexOf('style=\'\'') > -1) {
                                    value = value.replace(/<[^>]*>?/gm, '')
                                }
                            }
                            element.value = value
                            layers.push(element)
                        }
                    } else {
                        layers.push(element)
                    }
                } else if (mapTypes[type].length === 0) {
                    layers.push(element)
                }
                if (element.type === 'rect') {
                    backgrounds.push(element)
                }
                if (element.elements) {
                    getLayers(element, type)
                }
            }
        }
        if (!(type == 'vlines' || type == 'text-structure' || type == 'layout-structure')) {
            getLayers(tree, type)
        }
        $scope.view.paintIds = Array.from(new Set(paintIds))

        $timeout(angular.noop)
        $scope.render()

        if (type === 'fonts') {
            let fonts = []
            let fontMap = {}
            for (element of layers) {
                if (element.computed['font-family'] && !fontMap[element.computed['font-family']]) {
                    let clone = JSON.parse(JSON.stringify(element))
                    clone.originalId = clone.id
                    delete clone.id
                    clone.id = element.computed['font-family']
                    fonts.push({
                        value: element.computed['font-family'].replace(/"/g, ''),
                        name: element.value.replace(/<[^>]*>?/gm, ''),
                        originalId: clone.originalId,
                    })
                    fontMap[element.computed['font-family']] = true
                }
            }
            // Init brand kit from mapping kind
            if (!$scope.layout.brandKit) {
                $scope.layout.brandKit = {}
            }
            if (!$scope.layout.brandKit[type]) {
                $scope.layout.brandKit[type] = {}
            }
            // Map text kinds to fonts kinds
            let mappingTextFontsKinds = {
                'title': 'title',
                'description': 'body',
            }
            for (let layer of fonts) {
                if (!$scope.layout.brandKit[type][layer.id] && $scope.view.mappingKinds[layer.originalId]) {
                    let kind = $scope.view.mappingKinds[layer.originalId]
                    if (mappingTextFontsKinds[kind] && !$scope.layout.brandKit[type][mappingTextFontsKinds[kind]]) {
                        $scope.layout.brandKit[type][mappingTextFontsKinds[kind]] = layer.value
                    }
                }
            }
            layers = []
            $scope.view.availableValues.fonts = fonts
        } else if (type === 'colors') {
            let colors = getBackgroundColors(layers, [])
            colors = getTextColors(layers, colors)
            colors = getSVGColors(layers, colors)

            layers = colors.map(function(color) {
                return {
                    value: color,
                }
            })
            if (!$scope.layout.brandKit) {
                $scope.layout.brandKit = {}
            }
            if (!$scope.layout.brandKit[type]) {
                $scope.layout.brandKit[type] = {}
            }
            if (!$scope.layout.brandKit[type]['pallete']) {
                $scope.layout.brandKit[type]['pallete'] = []
            }
            $scope.layout.brandKit[type]['pallete'] = colors
            $scope.view.availableValues.colors = layers
            layers = []
        }
        updateMapping()
        $scope.view.currentLayers = layers
    }

    $scope.selectLayerById = function(id) {
        console.log('Selecting layer', id)
        let element = findElementsById($scope.layout.tree, id)
        if (element) {
            $scope.view.selectedLayer = element
        }
    }

    $scope.selectLayoutColor = function(color) {
        if (getActiveElement()) {
            let element = getActiveElement()
            if (element.type === 'rect') {
                element.computed.background = color
            } else if (element.type === 'p' || element.type === 'h1') {
                element.computed.color = color
            }
            $scope.refresh()
            return
        }
    }

    $scope.makeImageCover = function(position) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        element.computed['background-size'] = 'cover'
        if (!position || position === 'center') {
            element.computed['background-position'] = 'center'
        } else if (position === 'top') {
            element.computed['background-position'] = 'top center'
        } else if (position === 'bottom') {
            element.computed['background-position'] = 'bottom center'
        } else if (position === 'left') {
            element.computed['background-position'] = 'center left'
        } else if (position === 'right') {
            element.computed['background-position'] = 'center right'
        }
        $scope.render();
    }

    $scope.copyFont = function(pId) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        let currentLayers = $scope.view.currentLayers
        // Find font in current layers
        let found = currentLayers.find(function(layer) {
            return layer.pId?.toString() === pId.toString()
        })
        if (found) {
            element.computed['font-family'] = found.computed['font-family']
        }
        $scope.render()
    }

    $scope.copyColor = function(pId) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        let currentLayers = $scope.view.currentLayers
        // Find color in current layers
        let found = currentLayers.find(function(layer) {
            return layer.pId?.toString() === pId.toString()
        })
        if (found) {
            element.computed.color = found.computed.color
        }
        $scope.render()
    }

    $scope.applyColor = function(color) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        element.computed.color = color
        $scope.render()
    }


    $scope.getBackgroundStyle = function(element) {
        if (!element || !element.computed.background) {
            return null
        }
        let maxSize = 60
        let width = parseFloat(element.computed.width)
        let height = parseFloat(element.computed.height)
        let scale = 1
        if (width > height) {
            scale = maxSize / width
        } else {
            scale = maxSize / height
        }
        return {
            width: width * scale,
            height: height * scale,
            background: element.computed.background,
            border: '1px solid #ccc',
        }
    }

    $scope.updateTextValues = function(initial) {
        let textMap = {}
        document.querySelectorAll('[data-text-import-id]').forEach(function(element) {
            textMap[element.getAttribute('data-text-import-id')] = element.innerHTML
        })

        if (!$scope.layout.translation.original || !$scope.view.editingLanguage) {
            return
        }
        if (initial && $scope.layout.translation[$scope.view.editingLanguage]) {
            return
        }
        $scope.layout.translation[$scope.view.editingLanguage] = textMap

        if (initial) {
            return
        }
        $scope.onChangeEditingLanguage()
    }

    $scope.toggleTextsFixed = function() {
        let elements = []
        let mainElements = $scope.layout.tree.elements[INDEX_MAIN_ELEMENTS].elements
        for (let element of mainElements) {
            if (element.type === 'p' || element.type === 'h1' || element.type === 'span') {
                elements.push(element)
            }
        }

        let status = $scope.layout?.structure?.generation?.[elements[0].pId]
        $scope.layout.structure.generation = {}
        for (let element of elements) {
            if (element.pId) {
                if (!status) {
                    $scope.layout.structure.generation[element.pId] = 'fixed'
                } else {
                    delete $scope.layout.structure.generation[element.pId]
                }
            }
        }
    }

    $scope.toggleForceBg = function() {
        if (!$scope.layout?.paint?.map['main_bg']) {
            $scope.layout.paint = $scope.layout.paint || {}
            $scope.layout.paint.map = $scope.layout.paint.map || {}
            $scope.layout.paint.map['main_bg'] = {
                color: '#000000'
            }
        } else {
            delete $scope.layout.paint.map['main_bg']
        }
        $scope.render()
    }

    $scope.onChangeEditingLanguage = function() {
        $scope.updateTextValues(true)

        let mapTypes = {
            'text': ['p', 'h1'],
        }
        function updateLayers(tree) {
            for (let element of tree.elements) {
                if (mapTypes['text'].includes(element.type)) {
                    if (element.type === 'p') {
                        if ($scope.view.editingLanguage === $scope.layout.translation.original && $scope.layout.translation[$scope.layout.translation.original] && $scope.layout.translation[$scope.layout.translation.original][element.id]) {
                            // Reset to original
                            element.value = $scope.layout.translation[$scope.layout.translation.original][element.id]
                        } else if ($scope.layout.translation[$scope.view.editingLanguage] && $scope.layout.translation[$scope.view.editingLanguage][element.id]) {
                            let originalValue = element.value
                            if (!$scope.layout.translation[$scope.layout.translation.original]) {
                                $scope.layout.translation[$scope.layout.translation.original] = {}
                            }
                            // Set original only once
                            if (!$scope.layout.translation[$scope.layout.translation.original][element.id]) {
                                $scope.layout.translation[$scope.layout.translation.original][element.id] = originalValue
                            }
                            element.value = $scope.layout.translation[$scope.view.editingLanguage][element.id]
                        }
                    }
                }
                if (element.elements) {
                    updateLayers(element)
                }
            }
        }
        updateLayers($scope.layout.tree)
        $scope.updateLayers()
        $scope.render()
        $timeout(angular.noop)
    }

    $scope.refresh = function() {
        $scope.updateLayers()
        $scope.render()

        if (!visual) {
            return
        }
        if (!$scope.view.selectedLayer) {
            return
        }
        $timeout(function() {
            visualService.selectElement({
                elementId: $scope.view.selectedLayer.id,
                cardId: '0',
            })
        })
    }

    $scope.onInputsChange = function() {
        $scope.refresh()
    }

    $scope.isAdminImporter = function() {
        return $scope.features.import_advanced
    }

    $scope.isDynamicTemplateImporter = function() {
        return $scope.features.import_dynamic_templates
    }

    $scope.getCategories = function() {
        api.getImporterCategories().then(function(res) {
            function convertValues(item) {
                let row = {
                    value: item.key,
                    label: item.name,
                }
                if (item.keywords) {
                    row.keywords = item.keywords
                }
                return row
            }
            let data = res.data
            data.areas = data.areas.map(convertValues)
            data.areas.push({
                value: 'generic',
                label: 'Default',
            })
            data.categories = data.categories.map(convertValues)
            data.professions = data.professions.map(convertValues)
            data.objectives = data.objectives.map(convertValues)
            // Value/label map
            $scope.objectivesMap = {}
            data.objectives.forEach(function(objective) {
                $scope.objectivesMap[objective.value] = objective.label
            })
            for (style of data.styles) {
                style.values = style.values.map(convertValues)
            }
            if ($scope.isStyle()) {
                data.styles = data.styles.filter(style => style.id == 'gender')
            }
            data.styles = data.styles.filter(style => VALID_STYLES.includes(style.id))
            $scope.classification = data
            classificationMap = {
                "areas": {},
                "categories": {},
                "professions": {},
            }
            data.areas.forEach(function(item) {
                classificationMap.areas[item.value] = item.label
            })
            data.categories.forEach(function(item) {
                classificationMap.categories[item.value] = item.label
            })
            data.professions.forEach(function(item) {
                classificationMap.professions[item.value] = item.label
            })
        })
        .catch(function() {

        })
    }

    $scope.removeObjective = function(objective) {
        if (!$scope.layout.classification.content_types) {
            $scope.layout.classification.content_types = []
        }
        $scope.layout.classification.content_types = $scope.layout.classification.content_types.filter(function(item) {
            return item !== objective
        })
    }

    $scope.addObjective = function(objective) {
        if (!objective || typeof objective == 'undefined') {
            return
        }
        if (!$scope.layout.classification.content_types) {
            $scope.layout.classification.content_types = []
        }
        if ($scope.layout.classification.content_types.indexOf(objective) === -1) {
            $scope.layout.classification.content_types.push(objective)
        }
    }

    $scope.init = function() {
    }

    $scope.view.pages = []

    $scope.selectPage = function(page) {
        $scope.view.pages = $scope.view.pages.map(function(p) {
            p.active = p.id === page.id
            return p
        })

        delete $scope.view.originalLayout
        if ($scope.layouts[page.id]) {
            $scope.layout = $scope.layouts[page.id]
            if ($scope.layout.mapping || $scope.layout.dynamicMap) {
                $scope.view.mappingKinds = $scope.layout.mapping || $scope.layout.dynamicMap
            } else {
                $scope.view.mappingKinds = {}
            }
            if (!$scope.layout.classification) {
                $scope.layout.classification = {}
            }
            $scope.render()
            $scope.updateLayers()
            return
        }
        $scope.openImport($scope.importId)
    }

    $scope.createPages = function(number) {
        $scope.view.pages = Array.from({length: number}, (v, k) => k).map(function(index) {
            return {
                title: `Slide ${index + 1}`,
                id: index,
                active: index === 0,
            }
        })
    }

    $scope.openImport = function(importId) {
        $scope.view.loading = true
        currentHash = new Date().getTime()
        if (!$scope.view.pages || $scope.view.pages.length === 0) {
            $scope.createPages(1)
        }
        let currentPageId = $scope.view.pages.find(p => p.active).id

        api.getImportLayout(importId, currentPageId).then(function(response) {
            $scope.view.editingLanguage = response.data.layout.translation.original
            $scope.layouts[currentPageId] = response.data.layout
            $scope.layout = response.data.layout
            $scope.originalLayout = JSON.parse(JSON.stringify($scope.layout))
            if (currentPageId > 0 && $scope.view.mainBrandKit) {
                $scope.layout.brandKit = JSON.parse(JSON.stringify($scope.view.mainBrandKit))
            }
            $scope.view.mappingKinds = $scope.layout.dynamicMap || $scope.layout.mapping

            $scope.initialPreProcessing()
            $scope.loadFonts(response.data.layout.fonts)
            $scope.selectType('text')
            $scope.render()
        })
        .catch(function(error) {
            console.error('Error getting import layout', error)
            showError(gettext('error.generic'))
        })
        .finally(function() {
            $scope.view.loading = false
        })
    }

    function parseBrandKit(brandKit, currentPage) {
        if (currentPage === 0 && $scope.view.mainBrandKit) {
            return JSON.parse(JSON.stringify($scope.view.mainBrandKit))
        }

        if (!brandKit) {
            brandKit = {}
        }
        if (!brandKit.colors) {
            brandKit.colors = {}
        }
        if (!brandKit.fonts) {
            brandKit.fonts = {}
        }
        return brandKit
    }

    $scope.searchStyles = function() {
        api.getStyles({
            area: $scope.layout.classification.area,
        }).then(function(response) {
            $scope.view.styles = response.data.styles
            $scope.view.images = response.data.images
            $timeout(angular.noop)
        })
        .catch(function(error) {
            console.error('Error getting styles', error)
        })
    }

    $scope.selectImage = function(image) {
        for (let mapping in $scope.view.mappingKinds) {
            if ($scope.view.mappingKinds[mapping] === image.kind) {
                let element = findElementsById($scope.layout.tree, mapping)
                if (element) {
                    element.src = image.src
                    element.computed['background-repeat'] = 'no-repeat'
                }
                break
            }
        }
        $scope.render()
    }

    $scope.selectStyle = function(style) {
        $scope.view.theme.pallete.main = style.brandKit.colors.main
        $scope.view.theme.pallete.text = style.brandKit.colors.text
        $scope.view.theme.pallete.highlight = style.brandKit.colors.highlight
        $scope.refresh()
        if (!$scope.view.currentContent.title) {
            $scope.previewLayout()
        }
        $scope.view.selectedStyle = style
    }

    $scope.applyStyle = function() {
        // Replace images if there are imagens
        if (!$scope.view.originalLayout) {
            $scope.view.originalLayout = JSON.parse(JSON.stringify($scope.layout.tree))
        }
        let layoutString = JSON.stringify($scope.view.originalLayout || $scope.layout.tree, null, 2)
        let layoutBrandKit = $scope.layout.brandKit

        // Replace colors
        for (let color in layoutBrandKit.colors) {
            if (color == 'pallete') {
                continue
            }
            let rgb = hexToRgb(layoutBrandKit.colors[color])
            rgb = [rgb.red, rgb.green, rgb.blue]
            let rgbString = `rgb(${rgb.join(', ')})`
            // Escape regex
            rgbString = rgbString.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
            layoutString = layoutString.replace(new RegExp(rgbString, 'gm'), '###' + color + '###')
        }

        for (let color in layoutBrandKit.colors) {
            if (color == 'pallete') {
                continue
            }
            let replacedColor = $scope.view.selectedStyle.brandKit.colors[color]
            replacedColor = hexToRgb(replacedColor)
            replacedColor = `rgb(${replacedColor.red}, ${replacedColor.green}, ${replacedColor.blue})`
            layoutString = layoutString.replace(new RegExp('###' + color + '###', 'gm'), replacedColor)
        }

        // Replace fonts
        for (let font in layoutBrandKit.fonts) {
            layoutString = layoutString.replace(new RegExp(layoutBrandKit.fonts[font], 'gm'), '###' + font + '###')
        }

        for (let font in layoutBrandKit.fonts) {
            layoutString = layoutString.replace(new RegExp('###' + font + '###', 'gm'), $scope.view.selectedStyle.brandKit.fonts[font])
        }

        $scope.layout.brandKit = JSON.parse(JSON.stringify($scope.view.selectedStyle.brandKit))
        $scope.layout.tree = JSON.parse(layoutString)

        $scope.render()
    }

    $scope.editTemplate = function(templateId) {
        $scope.editingTemplateId = templateId
        $scope.view.currentSavedId = templateId
        api.editTemplate(templateId).then(function(response) {
            console.log('Edit template', response.data)
            $scope.view.pages = response.data.layouts.map(function(layout, index) {
                return {
                    // TODO - get text
                    title: `Slide ${index + 1}`,
                    id: index,
                    layoutId: layout._id,
                }
            })

            // TODO - Refactor
            $scope.layouts = response.data.layouts.map(function(l, index) {
                let translation = l.data.translation
                if (!translation) {
                    translation = {
                        original: 'en'
                    }
                }
                if (l.data.importId) {
                    $scope.importId = l.data.importId
                }
                return {
                    id: l._id,
                    mapping: l.data.mapping,
                    classification: l.data.classification,
                    structure: l.data.structure,
                    paint: l.data.paint,
                    tree: l.data.layout,
                    translation: translation,
                    importId: l.data.importId,
                }
            })
            $scope.view.mappingKinds = response.data.layouts[0].data.mapping
            $scope.selectPage($scope.view.pages[0])
            $scope.selectType('text')
            $timeout(angular.noop)
        })
        .catch(function(error) {
            console.error('Error getting import layout', error)
        })
    }

    $scope.parsePost = function(item, layout) {
        let itemConfig = {}
        //let itemTheme = Object.assign({}, $scope.state.data.theme)
        let itemTheme = $scope.view.theme

        // Keep the original theme for scheduled posts
        if ($scope.state && $scope.state.data && $scope.state.data.global && $scope.state.data.global.content) {
            itemConfig.global = Object.assign({}, $scope.state.data.global)
        }
        if (!itemTheme.global) {
            itemTheme.global = {}
        }
        if ($scope.layout.brandKit) {
            itemTheme.brandKit = $scope.layout.brandKit
        }
        itemTheme.global.showOriginalText = true
        let parsedPost = parserService.convertLayout(
            layout,
            item,
            itemTheme,
            //getContentForItem(item, itemConfig, 0),
            //getThemeForItem(itemTheme, item, 0)
        );
        return parsedPost
    }

    $scope.showPreviewTemplates = function() {

        function getBackgrounds(tree, backgrounds) {
            if (tree.type === 'rect') {
                backgrounds.push(tree)
            }
            if (tree.elements) {
                for (let element of tree.elements) {
                    getBackgrounds(element, backgrounds)
                }
            }
        }

        let backgrounds = []
        getBackgrounds($scope.layout.tree, backgrounds)

        $rootScope.$broadcast('import.templates.preview', {
            template: $scope.layout.tree,
            paint: $scope.layout.paint?.map || {},
            classification: $scope.layout.classification || {},
            elements: {
                backgrounds: backgrounds,
            }
        })
    }

    $scope.initialPreProcessing = function() {
        $scope.processLogo()
        $scope.addVerticalLines()

        let mainElementsMap = getMainElementsMap($scope.layout.tree)

        try {
            for (let id in mainElementsMap) {
                let element = mainElementsMap[id]
                // check if does not start with https
                if (element.type == 'image' && element.src && !element.src.startsWith('https://')) {
                    element.src = window.BASE_URL + element.src
                }
            }
        } catch (e) {
            console.error('Error processing images', e)
        }
        let invalidLayout = false
        // Check if any svg element has a image inside
        for (let key in mainElementsMap) {
            let el = mainElementsMap[key]
            if ((el.content && el.content.includes('<image')) || (el.value && el.value.includes('<image'))) {
                invalidLayout = true
                break
            }
        }
        if (invalidLayout) {
            showError(gettext('error.template_not_supported'))
        }
    }


    function addLogoSuggestedBox(layout, mainElements) {
        let logo = layout.structure.logo;

        let bbox = {
            x: parseFloat(logo.left),
            y: parseFloat(logo.top),
            width: parseFloat(logo.width),
            height: parseFloat(logo.height),
        }
        if (bbox.width <= 150) {
            bbox.width = 150
        }
        if (bbox.height <= 30) {
            bbox.height = 30
        }

        // May have been suggest a element_font_id, if found, get the font family from it
        let elementFontId = logo.suggested_element_font_id;
        let fontFamily = null;
        let fontColor = null
        mainElements.forEach(function(element) {
            if (element.pId === elementFontId && element.computed && element.computed['font-family']) {
                fontFamily = element.computed['font-family'];
                fontColor = element.computed.color;
            }
        })
        addLogo(mainElements, {
            bbox: bbox,
            font: {
                family: fontFamily,
                color: fontColor,
            }
        }, 'main_bg')
    }

    function addLogo(mainElements, params, paintBaseId) {
        let bbox = params.bbox
        let tree = $scope.layout.tree
        let fontFamily = null
        let fontColor = '#ffffff'
        // Find first p element with font-family sorted by texts length (longest first)
        let cloneMain = JSON.parse(JSON.stringify(mainElements))
        cloneMain = cloneMain.filter(e => e.type === 'p' && e.computed && e.computed['font-family'])
        cloneMain.sort(function(a, b) {
            if (a.type === 'p' && b.type === 'p') {
                return b.value.stripHtml().length - a.value.stripHtml().length
            }
            return 0
        })
        for (let element of cloneMain) {
            if (element.type === 'p' && element.computed && element.computed['font-family']) {
                fontFamily = element.computed['font-family']
                fontColor = element.computed.color || '#ffffff'
                break
            }
        }
        let fontSize = 13
        let logoElement = {
            type: 'p',
            pId: getNextPaintId(),
            computed: {
                color: fontColor,
                position: 'absolute',
                'font-family': fontFamily || 'sans-serif',
                'text-align': 'left',
                top: addPxIfNeeded(bbox.y),
                left: addPxIfNeeded(bbox.x),
                width: addPxIfNeeded(bbox.width),
                height: addPxIfNeeded(bbox.height),
                'font-size': addPxIfNeeded(fontSize),
            },
            replace: 'author.handle',
            value: '@logomarca',
        }
        mainElements.push(logoElement)
        tree.elements[INDEX_MAIN_ELEMENTS].elements = mainElements
        if (paintBaseId) {
            if (!$scope.layout.paint) {
                $scope.layout.paint = {}
            }
            if (!$scope.layout.paint.map) {
                $scope.layout.paint.map = {}
            }
            $scope.layout.paint.map[logoElement.pId] = {
                id: paintBaseId,
            }
        }
    }

    $scope.processLogo = function(ignoreMapping) {
        if ($scope.isNormalUser() || $scope.isDynamicTemplateImporter()) {
            return
        }
        let tree = $scope.layout.tree
        let mainElements = tree.elements[INDEX_MAIN_ELEMENTS].elements
        let logoIds = {}
        for (let id in $scope.view.mappingKinds) {
            if ($scope.view.mappingKinds[id] === 'logo') {
                logoIds[id] = true
            }
        }

        let requiredKeys = ['top', 'left', 'width', 'height', 'text_alignment', 'text_color'];
        let logo = $scope.layout.structure.logo || {};
        let hasSuggestedLogoBox = requiredKeys.every(key => logo[key] !== undefined)

        // Remove logo elements
        let logoElements = mainElements.filter(e => logoIds[e.id])
        if (logoElements.length > 0 && !ignoreMapping) {
            // Build a bbox which contains logo elements
            let bbox = {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            }
            let paintIdBase = 'main_bg'
            for (let logo of logoElements) {
                // Computed has px string
                if (!logo.computed) {
                    continue
                }
                let width = parseFloat(logo.computed.width)
                let height = parseFloat(logo.computed.height)
                let x = parseFloat(logo.computed.left)
                let y = parseFloat(logo.computed.top)
                if (bbox.width === 0 && bbox.height === 0) {
                    bbox.x = x
                    bbox.y = y
                    bbox.width = width
                    bbox.height = height
                } else {
                    bbox.x = Math.min(bbox.x, x)
                    bbox.y = Math.min(bbox.y, y)
                    bbox.width = Math.max(bbox.width, x + width - bbox.x)
                    bbox.height = Math.max(bbox.height, y + height - bbox.y)
                }
                if ((logo.type === 'p' || logo.type === 'h1') && $scope.layout?.paint?.map[logo.pId]) {
                    paintIdBase = $scope.layout.paint.map[logo.pId].id
                }
            }
            // Area of logo
            let area = bbox.width * bbox.height
            if (area <= 10000) {
                // Remove logo elements from main elements
                mainElements = mainElements.filter(e => !logoIds[e.id])
                if (bbox.width < 150) {
                    bbox.width = 150
                }
                if (bbox.height < 30) {
                    bbox.height = 30
                }
                addLogo(mainElements, {bbox}, paintIdBase)
            } else {
                let bbox = {
                    x: 30,
                    y: 20,
                    width: 150,
                    height: 30,
                }
                // Unset all dynamic mapping for logos
                let idsToDelete = []
                for (let id in $scope.view.mappingKinds) {
                    if ($scope.view.mappingKinds[id] === 'logo') {
                        idsToDelete.push(id)
                    }
                }
                for (let id of idsToDelete) {
                    delete $scope.view.mappingKinds[id]
                }
                addLogo(mainElements, {bbox}, 'main_bg')
            }
        } else if (hasSuggestedLogoBox && !ignoreMapping) {
            addLogoSuggestedBox($scope.layout, mainElements)
        } else {
            // If no logo elements, add a default logo
            let bbox = {
                x: 30,
                y: 20,
                width: 150,
                height: 30,
            }
            addLogo(mainElements, {bbox}, 'main_bg')
        }
        $scope.refresh()
    }

    $scope.updateVerticalLines = function(mapPaintIdToEl, mainElements, showVlines) {
        let vlines = $scope.getCurrentVlines()
        if (Array.isArray(vlines)) {
            let index = 0
            for (let vline of vlines) {
                let vlineColor = $scope.vlinesColors[index % $scope.vlinesColors.length]
                for (let id of vline.ids) {
                    if (mapPaintIdToEl[id]) {
                        let element = mapPaintIdToEl[id]
                        let isText = (element) => element.type === 'p' || element.type === 'h1'
                        let isNotRightAligned = (element) => {
                            return !element.computed || !element.computed['text-align'] || (element.computed['text-align'] !== 'right' && element.computed['text-align'] !== 'center')
                        }
                        if (element.computed && isText(element) && isNotRightAligned(element)) {
                            let newWidth = parseFloat(vline.x) - parseFloat(element.computed.left)
                            if (newWidth > 0 && newWidth > parseFloat(element.computed.width)) {
                                element.computed.width = addPxIfNeeded(newWidth)
                            }
                        }
                        if (showVlines) {
                            element.computed['outline'] = '1px solid ' + vlineColor;
                        }
                    }
                }
                if (showVlines) {
                    mainElements.push({
                        type: 'rect',
                        computed: {
                            position: 'absolute',
                            left: addPxIfNeeded(vline.x),
                            height: '100%',
                            width: '2px',
                            'border-width': '2px',
                            'border-style': 'dashed',
                            'border-color': vlineColor,
                        }
                    })
                }
                index++
            }
        }
    }

    $scope.isInvalidTab = function(type) {
        if (!$scope?.layout?.structure) {
            return false
        }
        if (!$scope.layout) {
            return false
        }
        if (type === 'vlines') {
            if (!$scope.layout.structure.vlines) {
                return true
            }
            return $scope.layout.structure.vlines.length === 0
        }
        if (type === 'text-structure') {
            if (!$scope.layout.structure.text) {
                return true
            }
            if (Object.keys($scope.layout.structure.text).length === 0) {
                return true
            }
        }
        return false
    }

    $scope.addVerticalLines = function() {
        if (!$scope.isAdvanced() || $scope.isDynamicTemplateImporter()) {
            return
        }
        let index = 0
        let textCtas = {}
        let mainElementsMap = getMainElementsMap($scope.layout.tree)
        if ($scope.layout.structure.ctas) {
            for (let group of $scope.layout.structure.ctas) {
                for (let element of group.elements) {
                    if (mainElementsMap[element.id] && ['p', 'span', 'h1'].includes(mainElementsMap[element.id].type)) {
                        textCtas[element.id] = true
                    }
                }
            }
        }
        if (Array.isArray($scope.layout.structure.vlines)) {
            for (let vline of $scope.layout.structure.vlines) {
                for (let id of vline.ids) {
                    if (textCtas[id]) {
                        continue
                    }
                    $scope.view.vlines.mapIds[id] = index
                }
                $scope.view.vlines.rows.push({
                    value: parseFloat(vline.x),
                })
                index++
            }
        } else {
            showError('Linhas verticais inválidas')
        }

    }

    $scope.removeVline = function(index) {
        $scope.view.vlines.rows.splice(index, 1)
        // Go through all elements and remove the vline id $scope.view.vlines.mapIds
        for (let id in $scope.view.vlines.mapIds) {
            if ($scope.view.vlines.mapIds[id] === index) {
                delete $scope.view.vlines.mapIds[id]
            } else if ($scope.view.vlines.mapIds[id] > index) {
                $scope.view.vlines.mapIds[id]--
            }
        }
        $scope.previewLayout()
    }

    $scope.addVline = function() {
        // Add a new vline at the end of the list
        let newVline = {
            value: 10,
        }
        $scope.view.vlines.rows.push(newVline)
        $scope.previewLayout()
    }

    $scope.getCurrentVlines = function() {
        // Convert back to the original structure
        let vlines = []
        let idsToDelete = []
        for (let id in $scope.view.vlines.mapIds) {
            let index = $scope.view.vlines.mapIds[id]
            if (typeof index === 'undefined' || index === null || index === '') {
                idsToDelete.push(id)
            }
        }
        for (let id of idsToDelete) {
            delete $scope.view.vlines.mapIds[id]
        }

        for (let id in $scope.view.vlines.mapIds) {
            let index = $scope.view.vlines.mapIds[id]
            if (!vlines[index]) {
                vlines[index] = {
                    x: 0,
                    ids: [],
                }
            }
            vlines[index].x = $scope.view.vlines.rows[index].value
            vlines[index].ids.push(id)
        }
        return Object.values(vlines).filter(function(vline) {
            return vline.ids.length > 0;
        });
    }

    $scope.updateCTAs = function() {
         const replaceCTA = false
        // Build dynamic cta
        if (replaceCTA) {
            for (let group of $scope.layout.structure.ctas) {
                let elements = []
                let mapCta = {}
                for (let el of group.elements) {
                    if (mapPaintIdToEl[el.id]) {
                        let element = mapPaintIdToEl[el.id]
                        if (typeof mapCta[el.slot] === 'undefined') {
                            mapCta[el.slot] = []
                        }
                        mapCta[el.slot].push(JSON.parse(JSON.stringify(element)))
                        elements.push(element)
                    }
                }
                // It needs to have only one text element and only one bg
                if (mapCta.text?.length !== 1 || mapCta.background?.length !== 1) {
                    console.warn('Invalid dynamic cta', group, mapCta)
                    continue
                }
                // Create a new container element for cta. it is positiona abs in the bg bbox
                let ctaElement = {
                    type: 'container',
                    computed: {
                        position: 'absolute',
                        top: mapCta.background[0].computed.top,
                        left: mapCta.background[0].computed.left,
                        height: mapCta.background[0].computed.height,
                    },
                    elements: [],
                }
                // Add background element
                let bgElement = mapCta.background[0] || mapCta.background
                bgElement.computed.position = 'absolute'
                delete bgElement.computed.top
                delete bgElement.computed.left
                bgElement.computed.width = '100%'
                bgElement.computed.height = '100%'
                ctaElement.elements.push(bgElement)

                // TODO - Improve may not be arrays
                let textElement = mapCta.text[0] || mapCta.text
                let iconElement = mapCta.icon ? mapCta.icon[0] : null
                let iconPosition = ''
                // Compare iconElement with textElement
                if (iconElement && textElement) {
                    if (iconElement.computed.left < textElement.computed.left) {
                        iconPosition = 'left'
                    } else {
                        iconPosition = 'right'
                    }
                }
                // If has icon and icon right, add ppadding to text on right, vice versa
                if (iconElement && iconPosition === 'right') {
                    textElement.computed.paddingRight = iconElement.computed.width || '0px'
                } else if (iconElement && iconPosition === 'left') {
                    textElement.computed.paddingLeft = iconElement.computed.width || '0px'
                }
                if (textElement) {
                    delete textElement.computed.top
                    delete textElement.computed.left
                    delete textElement.computed.right
                    delete textElement.computed.bottom
                    delete textElement.computed.width
                    delete textElement.computed.position
                }
                ctaElement.elements.push(textElement)

                console.log('CTA Element', ctaElement);
                mainElements = mainElements.filter(e => !elements.some(el => el.pId === e.pId));
                mainElements.push(ctaElement);
                tree.elements[INDEX_MAIN_ELEMENTS].elements = mainElements;
            }
        }
    }

    function getMainElementsMap(tree) {
        let mapPaintIdToEl = {}
        let mainElements = tree.elements[INDEX_MAIN_ELEMENTS].elements
        for (let element of mainElements) {
            mapPaintIdToEl[element.pId] = element
        }
        return mapPaintIdToEl
    }

    function getMainElements(tree) {
        return Object.values(getMainElementsMap(tree))
    }

    $scope.getTreeProcessed = function(kind) {
        let tree = JSON.parse(JSON.stringify($scope.layout.tree))
        let mapPaintIdToEl = {}
        let mainElements = tree.elements[INDEX_MAIN_ELEMENTS].elements
        for (let element of mainElements) {
            mapPaintIdToEl[element.pId] = element
        }
        if (!tree.structure) {
            tree.structure = {}
        }
        if (!tree.structure.groups) {
            tree.structure.groups = {}
        }
        for (let groupId of $scope.view.enabledGroups) {
            tree.structure.groups[groupId] = true
        }

        let palette = getRandomPallete()
        let palletsArray = Object.values(palette);
        palletsArray.sort(() => Math.random() - 0.5);
        palette = {
            main: palletsArray[0],
            text: palletsArray[1],
            highlight: palletsArray[2],
        };
        if ($scope.view.repaintEnabled) {
            console.log('Repainting with palette', $scope.layout.paint)
            repaint(tree, $scope.layout.paint, palette)
        }
        if ($scope.view.vlinesEnabled) {
            $scope.updateVerticalLines(mapPaintIdToEl, mainElements, $scope.view.showVlines)
        }
        return tree
    }

    $scope.getLayoutProcessedForSaving = function() {
        let layout = JSON.parse(JSON.stringify($scope.layout))

        let tree = layout.tree
        let mapPaintIdToEl = {}
        let mainElements = tree.elements[INDEX_MAIN_ELEMENTS].elements
        for (let element of mainElements) {
            mapPaintIdToEl[element.pId] = element
        }
        if ($scope.view.vlinesEnabled) {
            $scope.updateVerticalLines(mapPaintIdToEl, mainElements, false)
        }

        return layout
    }

    let debounceVisual = null
    $scope.render = function() {
        $scope.parsedPosts = []

        let kind = 'default'
        let content = $scope.view.repaintEnabled ? $scope.view.currentContent : {}
        let parsedPost = $scope.parsePost(content, $scope.getTreeProcessed(kind))

        $scope.parsedPosts.push(parsedPost)
        $timeout(angular.noop)

        if (debounceVisual) {
            clearTimeout(debounceVisual)
        }
        debounceVisual = setTimeout(function() {
            $scope.visualInit()
        }, 100)
    }

    $scope.load = function() {
        $scope.view.loading = true
        $timeout(angular.noop)
    }
    $scope.finish = function() {
        $scope.view.loading = false
        $timeout(angular.noop)
    }

    $scope.cleanImport = function() {
        $scope.view = JSON.parse(JSON.stringify(INITIAL_VIEW))
    }

    $scope.getPageScreenshotURL = function() {
        return '/public/imported/' + $scope.importId + '/0/screenshot.png' + '?t=' + currentHash
    }

    $scope.getNextTemplate = function() {
        $scope.view.loading = true
        $scope.view.pages = []
        $scope.layouts = []
        $scope.parsedPosts = []
        api.getNextTemplate($scope.importURL, $scope.view.reviewing, $scope.editingTemplateId).then(function(response) {
            $scope.stats = response.data.stats
            if (response?.data?.importId) {
                $scope.editTemplate(response.data.importId)
            }
            else if (response?.data?.url) {
                $scope.importURL = response.data.url
                $scope.parseLayout()
            }
            $timeout(angular.noop)
        })
        .finally(function() {
            $scope.view.loading = false
        })
    }
    $scope.parseLayout = function(forceFetch) {
        if (!$scope.importURL) return

        $scope.isDuplicate = false
        $scope.cleanImport()

        $scope.load()

        api.processImport({
            url: $scope.importURL,
            refresh: !!forceFetch,
        }).then(function(response) {
            if (response?.data?.error) {
                if (response?.data?.error == 'invalid_url') {
                    showError(gettext('error.invalid_canva_url'))
                } else {
                    showError(gettext('error.generic'))
                }
                return
            }
            if (response.data.result.pages) {
                $scope.createPages(response.data.result.pages)
            }
            $scope.importId = response.data.result.id
            $scope.view.currentSavedId = null
            $scope.openImport(response.data.result.id)
        })
        .catch(function(error) {
            console.error('Error parsing layout', error)
            showError(gettext('error.generic'))
        })
        .finally(function() {
            $scope.finish()
        })
    }

    $scope.parseAsStyle = function() {
        $scope.importAsStyle = true
        $scope.getCategories()
        $scope.parseLayout()
        $timeout(function() {
            $scope.selectType('colors')
        }, 500)
    }

    let visualService = null
    $scope.visualInit = function() {
        if (visualService) {
            visualService.destroy()
            visualService = null
        }
        visualService = new visual({
            id: 0,
        })
        visualService.init({
            select: function(element) {
                $timeout(function() {
                    $scope.selectLayerById(element.elementId)
                })
                console.log('Select', element)
                $timeout(angular.noop)
            },
            deselect: function(element) {
                console.log('Deselect', element)
                $timeout(function() {
                    $scope.view.selectLayer = null
                })
            },
            update: function(change) {
                console.log('Change', change, 'Selected layer', $scope.view.selectedLayer)
                if (change.values.translate) {
                    let translate = change.values.translate
                    if ($scope.view.selectedLayer.computed.top) {
                        $scope.view.selectedLayer.computed.top = (parseFloat($scope.view.selectedLayer.computed.top) + translate.y) + 'px'
                    } else if ($scope.view.selectedLayer.compute.bottom) {
                        $scope.view.selectedLayer.computed.bottom = (parseFloat($scope.view.selectedLayer.computed.bottom) + translate.y) + 'px'
                    }
                    if ($scope.view.selectedLayer.computed.left) {
                        $scope.view.selectedLayer.computed.left = (parseFloat($scope.view.selectedLayer.computed.left) + translate.x) + 'px'
                    } else if ($scope.view.selectedLayer.computed.right) {
                        $scope.view.selectedLayer.computed.right = (parseFloat($scope.view.selectedLayer.computed.right) + translate.x) + 'px'
                    }
                }
                // Do similarly for width and height
                if (change.values.width) {
                    $scope.view.selectedLayer.computed.width = change.values.width
                }
                if (change.values.height) {
                    $scope.view.selectedLayer.computed.height = change.values.height
                }
                $scope.render()
            },
            render: function() {
                console.log('Render')
                //$scope.refreshVisual()
            }
        }, {
            cardId: -1,
            theme: {
                settings: {}
            }
        }, {
            wrapperSelector: '#importer-wrapper',
            useOriginalIds: true,
        })
    }
    $scope.getHueFilter = function() {
        if (!$scope.selectedColor) return {}
        let baseColor = HEXtoHSL('#533920') //returns array [h,s,l]
        let selectedColor = HEXtoHSL($scope.selectedColor) //returns array [h,s,l]
        // Diff in hue
        let hueDiff = selectedColor[0] - baseColor[0]
        let saturationDiff = selectedColor[1]/baseColor[1]
        let lightnessDiff = selectedColor[2]/baseColor[2]
        lightnessDiff = 1
        return {
            'filter': `hue-rotate(${hueDiff}deg) saturate(${saturationDiff}) brightness(${lightnessDiff})`
        }
    }

    $scope.loadFonts = function(fonts) {
        for (let font in fonts) {
            let fontFace = new FontFace(font, `url(${fonts[font]})`);
            document.fonts.add(fontFace);
            fontFace.load().then(function(loadedFont) {
                //console.log('Font loaded', loadedFont);
            }).catch(function(error) {
                console.error('Font failed to load', error);
            });
        }
    }

    $scope.importStyle = function() {
        $scope.importLayout('style')
    }

    $scope.duplicateStyle = function() {
        if (!$scope.view.selectedStyle) {
            return
        }
        $scope.isDuplicate = true
        $scope.importLayout('style', $scope.view.selectedStyle.brandKit)
    }

    $scope.clearLogoMappings = function() {
        $scope.layout = JSON.parse(JSON.stringify($scope.originalLayout))
        for (let mapping in $scope.view.mappingKinds) {
            if ($scope.view.mappingKinds[mapping] === 'logo') {
                delete $scope.view.mappingKinds[mapping]
            }
        }
        $scope.updateLayers()
        $scope.render()
    }

    $scope.clearPaintMappings = function(type) {
        let idsToRemove = null
        if (type) {
            idsToRemove = $scope.view.currentLayers.map(item => item.pId)
        }
        if (idsToRemove && idsToRemove.length > 0) {
            // Remove elements from main elements
            for (let id of idsToRemove) {
                delete $scope.layout.paint.map[id]
            }
        } else {
            $scope.layout.paint = {}
        }
        $scope.render()
    }

    $scope.removeClipPath = function() {
        let activeElement = getActiveElement()
        if (!activeElement || !activeElement.computed || !activeElement.computed['clip-path']) {
            return
        }
        delete activeElement.computed['clip-path']
        $scope.render()
    }

    $scope.validateLayout = function() {
        let errors = []
        if (!$scope.layout.paint || Object.keys($scope?.layout?.paint?.map || {}).length === 0) {
            errors.push("Mapa de identidade visual não encontrado ou inválido")
        }

        if (!$scope.isDynamicTemplateImporter()) {
            if (!$scope?.layout?.classification?.content_types || $scope?.layout?.classification?.content_types.length === 0) {
                errors.push("Classificação de conteúdo não encontrada ou inválida")
            }
            if (!$scope.layout.structure.text || Object.keys($scope.layout.structure.text).length === 0) {
                errors.push("Estrutura de texto não encontrada ou inválida")
            }

            if (!$scope.view.vlinesEnabled && USE_VERTICAL_LINES) {
                errors.push("Linhas verticais não estão habilitadas (confira)")
            }
            let mainElements = getMainElements($scope.layout.tree)
            let hasLogo = mainElements.some(e => e.replace === 'author.handle')
            if (!hasLogo) {
                errors.push("Logomarca não encontrada. Verifique se o layout possui uma logomarca mapeada.")
            }
        }

        // TODO - check for logomarca
        let valid = errors.length === 0
        return {
            valid: valid,
            message: valid ? '' : errors.join(', ')
        }
    }

    $scope.importLayoutWithConfirm = function(kind, forceBrandKit = null) {
        let result = $scope.validateLayout()

        if (!result.valid && $scope.isAdvanced()) {
            showConfirm(result.message, null, function (status) {
                if (status) {
                    $scope.importLayout(kind, forceBrandKit)
                }
            })
        } else {
            if ($scope.isAdvanced() && !$scope.isDynamicTemplateImporter()) {
                try {
                    let currentPage = $scope.view.pages.find(p => p.active)
                    let existingLayoutId = currentPage.layoutId
                    if (!existingLayoutId) {
                        let confirmMessage = ''
                        let rows = [
                            'Classificação', $scope.layout.classification.content_types.map(t => $scope.objectivesMap[t]).join(', ') || 'Nenhuma',
                            'Category', classificationMap.categories[$scope.layout.classification.category] || 'Nenhuma',
                        ]
                        for (let i = 0; i < rows.length; i += 2) {
                            confirmMessage += `<b>${rows[i]}:</b> ${rows[i+1]}<br/>`
                        }
                        confirmMessage += '<br/>Confirma importar este template?'

                        showConfirm(confirmMessage, null, function (status) {
                            if (status) {
                                $scope.importLayout(kind, forceBrandKit)
                            }
                        })
                        return
                    } else {
                        $scope.importLayout(kind, forceBrandKit)
                    }
                } catch (e) {
                    console.error('Error checking existing layout', e)
                }
            } else {
                $scope.importLayout(kind, forceBrandKit)
            }
        }
    }

    $scope.skipTemplate = function(reason) {
        showConfirm('Confirma ignorar o template?', null, function (status) {
            if (status) {
                api.skipTemplate($scope.importURL, reason ? reason : 'default')
                .then(function() {
                    $scope.getNextTemplate()
                })
                .catch(function(error) {
                    showError(gettext('error.generic'))
                })
            }
        })
    }

    $scope.publishTemplate = function(status) {
        api.publishLayoutById({
            id: $scope.editingTemplateId,
            public: status
        })
        .then(function() {
            $scope.getNextTemplate()
        })
        .catch(function() {
        })
    }

    $scope.importLayout = function(kind, forceBrandKit = null) {
        console.log('Importing layout')

        $scope.view.editingLanguage = $scope.layout.translation.original
        $scope.onChangeEditingLanguage()

        let currentPage = $scope.view.pages.find(p => p.active)
        let firstPage = $scope.view.pages[0]
        let existingLayoutId = currentPage.layoutId
        let params = {
            layout: $scope.getLayoutProcessedForSaving(),
            mappingKinds: $scope.view.mappingKinds
        }
        params.layout.page = currentPage.id
        if (existingLayoutId && !forceBrandKit) {
            params._id = existingLayoutId
        }
        let currentBrandKit = forceBrandKit || params.layout.brandKit
        params.layout.brandKit = parseBrandKit(currentBrandKit, currentPage.id)

        if (currentPage.id === 0 && !forceBrandKit) {
            $scope.view.mainBrandKit = params.layout.brandKit
        }

        if (currentPage.id > 0) {
            // First pages need to be saved first
            if (!firstPage.layoutId) {
                alert('Please save the first page first')
                return
            }
            params.parentId = firstPage.layoutId
        }
        if ($scope.projectId) {
            params.projectId = $scope.projectId
        }
        if (kind && kind === 'style') {
            params.importAsStyle = true
        }
        if ($scope.isDuplicate) {
            params.duplicate = true
        }
        if ($scope.importURL) {
            params.importURL = $scope.importURL
        }

        $scope.load()
        api.saveImport(params).then(function(response) {
            if (response && response.data && response.data.id) {
                showSuccess(gettext('label.import_layout_success'))
                currentPage.layoutId = response.data.id
                $scope.view.currentSavedId = response.data.id
                if ($scope.isNormalUser()) {
                    angular.element('#import-modal').modal('hide')
                    $rootScope.$emit('reloadUserLayouts')
                }
            } else {
                showError(gettext('error.generic'))
            }
        })
        .catch(function(error) {
            console.error('Error importing layout', error)
        })
        .finally(function() {
            $scope.finish()
        })
    }

    function findElementsByIds(tree, ids) {
        let elements = []
        for (let element of tree.elements) {
            if (ids.includes(element.id)) {
                elements.push(element);
            }
            if (element.elements) {
                elements = elements.concat(findElementsByIds(element, ids));
            }
        }
        return elements;
    }

    function findElementsById(tree, id) {
        let elements = findElementsByIds(tree, [id]);
        if (elements.length) {
            return elements[0];
        }
        else {
            return null;
        }
    }

    function removeByIds(tree, ids) {
        for (let i = tree.elements.length - 1; i >= 0; i--) {
            let element = tree.elements[i];
            if (ids.includes(element.id)) {
                tree.elements.splice(i, 1);
            } else if (element.elements) {
                removeByIds(element, ids);
            }
        }
    }

    function getActiveElement() {
        if (!$scope.view.selectedLayer) {
            return null
        }
        return findElementsById($scope.layout.tree, $scope.view.selectedLayer.id)
    }

    $scope.reloadSaved = function() {
        if (!$scope.view.currentSavedId) {
            return
        }
        $scope.editTemplate($scope.view.currentSavedId)
    }

    $scope.removePage = function() {
        // Find active page
        let currentPage = $scope.view.pages.find(p => p.active)
        if (!currentPage) {
            return
        }
        if (!currentPage.layoutId) {
            return
        }
        if (confirm('Are you sure you want to remove this page?')) {
            api.removeLayout(currentPage.layoutId).then(function(response) {
                $scope.editTemplate($scope.view.pages[0].layoutId)
            }).catch(function(error) {
                console.error('Error removing layout', error)
            })
        }
    }

    $scope.duplicatePage = function() {
        let newPage = {
            // TODO - get text
            title: `Slide ${$scope.view.pages.length + 1}`,
            id: $scope.view.pages.length,
        }

        $scope.layouts[newPage.id] = JSON.parse(JSON.stringify($scope.layout))
        $scope.layouts[newPage.id].page = newPage.id
        $scope.view.pages.push(newPage)

        $scope.selectPage(newPage)
    }

    $scope.translateLayout = function() {
        let params = {
            source: $scope.layout.translation.original,
            target: $scope.view.editingLanguage,
        }

        let texts = $scope.layout.translation[$scope.layout.translation.original]
        if (!texts) {
            return
        }

        const TRANSLATION_MAP = {
            'pt': {
                'address': 'Avenida Brasil, 1723',
                'phone': '+55 11 1234-5678',
                'website': 'www.meusite.com.br',
                'email': 'contato@negocio.com.br',
            },
        }
        let fixedTranslation = {}
        // Ignore some texts that have the mapping above $scope.view.mappingKinds
        for (let key in texts) {
            let kind = $scope.view.mappingKinds[key]
            if (kind && TRANSLATION_MAP[params.target] && TRANSLATION_MAP[params.target][kind]) {
                fixedTranslation[key] = TRANSLATION_MAP[params.target][kind]
                delete texts[key]
            }
        }

        params.texts = texts
        api.translateTexts(params).then(function(response) {
            let translation = response.data
            translation = Object.assign(translation, fixedTranslation)
            // Only keep translation keys that exist in the original
            for (let key in translation) {
                document.querySelectorAll(`[data-text-import-id="${key}"]`).forEach(function(element) {
                    element.innerHTML = translation[key]
                    $scope.layout.translation[$scope.view.editingLanguage][key] = translation[key]
                })
            }

            $scope.updateTextValues()
            $scope.onChangeEditingLanguage()
        })
        .catch(function(error) {
            console.error('Error translating texts', error)
        })
    }

    // Editor actions
    $scope.changePostSize = function(size) {
        $scope.view.postSize = size

        let mapSizes = {
            'square': {
                width: 1,
                height: 1
            },
            'portrait': {
                width: 1,
                height: 1.25
            },
            'story': {
                width: 1,
                height: 1.777777777778
            },
        }
        console.log('Changing size', size)
        $scope.view.theme.size = mapSizes[size]
        $scope.render()
    }

    $scope.selectLayer = function(layer) {
        $scope.view.selectedLayer = layer

        if (!visualService) {
            return
        }
        visualService.selectElement({
            elementId: layer.id,
            cardId: '0',
        })
    }

    function findIndexBackgroundToInsert() {
        let index = 0
        for (let i = 0; i < $scope.layout.tree.elements.length; i++) {
            if ($scope.layout.tree.elements[i].type === 'container' && index > 0) {
                index = i
                break
            }
        }
        return index
    }

    $scope.unsetImage = function(layer) {
        if (layer.type === 'image') {
            delete layer.src
            $scope.render()
        }
    }

    $scope.removeElement = function() {
        let element = getActiveElement()
        if (!element) {
            return
        }
        removeByIds($scope.layout.tree, [element.id])
        $scope.updateLayers()
        $scope.render()
    }

    $scope.moveTo = function(kind) {
        const element = getActiveElement()
        if (!element) return

        const TARGETS = {
            background: INDEX_BG,
            foreground: INDEX_MAIN_ELEMENTS,
            home: -1,
        }
        const targetIndex = TARGETS[kind]
        if (targetIndex == null) {
            console.warn('moveTo: unknown kind:', kind)
            return
        }

        let targetSection = null
        if (targetIndex === -1) {
            targetSection = $scope.layout.tree
        } else {
            targetSection = $scope.layout.tree.elements[targetIndex]
        }
        if (!targetSection || !Array.isArray(targetSection.elements)) {
            console.warn('moveTo: target section not found:', targetIndex, targetSection)
            return
        }

        // === TODO implemented: ignore if already in the right place ===
        const alreadyInTarget = targetSection.elements.some(e => e && e.id === element.id)
        if (alreadyInTarget) {
            return
        }

        // Remove from current location and add to target
        removeByIds($scope.layout.tree, [element.id])

        targetSection.elements.push(element)

        $scope.render()
    }

    $scope.createTextWrapperContainer = function() {
        let container = {
            id: 'text',
            type: 'container',
            align: 'center',
            hpos: 'center',
            vpos: 'center',
            elements: [],
            computed: {},
        }

        let contentContainerIndex = null
        for (let i = $scope.layout.tree.elements.length - 1; i >= 0; i--) {
            if ($scope.layout.tree.elements[i].type === 'container') {
                contentContainerIndex = i
                break
            }
        }
        if (!contentContainerIndex) {
            alert('No container found')
            return
        }
        function getElementByType(kind) {
            for (let key in $scope.view.mappingKinds) {
                if ($scope.view.mappingKinds[key] === kind) {
                    let element = findElementsById($scope.layout.tree, key)
                    if (element) {
                        return element
                    }
                }
            }
            return null
        }
        function cleanElements(element) {
            // Remove width, top, left, right, bottom from computed
            element.computed.width = '100%'
            delete element.computed.height
            delete element.computed.top
            delete element.computed.left
            delete element.computed.right
            delete element.computed.bottom
            element.computed.position = 'relative'
        }

        let descriptionEl = getElementByType('description')
        let titleEl = getElementByType('title')
        if (!descriptionEl || !titleEl) {
            alert('No title or description found')
            return
        }

        function getBBox(style) {
            return {
                x: parseFloat(style.left),
                y: parseFloat(style.top),
                width: parseFloat(style.width),
                height: parseFloat(style.height),
            }
        }
        function joinBBox(bbox1, bbox2) {
            let x = Math.min(bbox1.x, bbox2.x)
            let y = Math.min(bbox1.y, bbox2.y)
            let width = Math.max(bbox1.x + bbox1.width, bbox2.x + bbox2.width) - x
            let height = Math.max(bbox1.y + bbox1.height, bbox2.y + bbox2.height) - y
            return {
                x: x,
                y: y,
                width: width,
                height: height,
            }
        }
        // Update container bbox to be the combined bbox of title and description
        let bboxTitle = getBBox(titleEl.computed)
        let bboxDescription = getBBox(descriptionEl.computed)

        let bbox = joinBBox(bboxTitle, bboxDescription)
        container.computed.width = bbox.width + 'px'
        container.computed.height = bbox.height + 'px'
        container.computed.top = bbox.y + 'px'
        container.computed.left = bbox.x + 'px'

        cleanElements(descriptionEl)
        cleanElements(titleEl)

        titleEl.fitToParent = true

        container.elements.push(titleEl)
        container.elements.push(descriptionEl)

        // Remove from tree
        removeByIds($scope.layout.tree, [titleEl.id, descriptionEl.id])

        $scope.layout.tree.elements[contentContainerIndex].elements.push(container)
        $scope.onInputsChange()
    }

    $scope.moveToBackground = function() {
        $scope.moveTo('background')
    }

    $scope.moveToFront = function() {
        $scope.moveTo('foreground')
    }

    $scope.moveToHome = function() {
        $scope.moveTo('home')
    }

    $scope.alignTop = function() {
        let element = getActiveElement()
        if (!element) {
            return
        }

        $scope.moveToBackground()

        delete element.computed.bottom
        let rotation = parseFloat(element.computed.rotate) || 0;
        rotation = ((rotation % 360) + 360) % 360;

        if (rotation === 90 || rotation === 270) {
            const elWidth = parseFloat(element.computed.width) || 0;
            const elHeight = parseFloat(element.computed.height) || 0;
            const extra = -(elHeight - elWidth) / 2; // opposite sign from bottom
            element.computed.top = `${extra}px`;
        } else {
            element.computed.top = '0px';
        }
        $scope.render()
    }

    $scope.alignBottom = function() {
        $scope.moveToBackground()
        let element = getActiveElement()
        if (!element) {
            return
        }

        delete element.computed.top

        let rotation = parseFloat(element.computed.rotate) || 0;
        rotation = ((rotation % 360) + 360) % 360;

        if (rotation === 90 || rotation === 270) {
            const elWidth = parseFloat(element.computed.width) || 0;
            const elHeight = parseFloat(element.computed.height) || 0;
            const extra = -(elHeight - elWidth)/2
            element.computed.bottom = `${extra}px`;
        } else {
            element.computed.bottom = '0px';
        }
        $scope.render()
    }

    $scope.makeFullScreen = function(kind, el) {
        let element = null
        if (!el) {
            $scope.moveToBackground()
            element = getActiveElement()
        } else {
            element = el
        }

        if (!element) {
            return
        }

        if (kind === 'width' || kind === 'fullscreen') {
            element.computed.width = '100%'
        }
        if (kind === 'height' || kind === 'fullscreen') {
            element.computed.height = '100%'
            element.computed.top = '0px'
        }
        if (element.type === 'svg' && (kind === 'height' || kind === 'fullscreen')) {
            // SVGs need to have width set to auto to maintain aspect ratio
            element.computed.width = 'auto'
        }
        if (element.type === 'image' && element.src) {
            element.computed['background-size'] = 'cover'
        }
        $scope.render()
    }

    $scope.makeFullHeightForeground = function(el, kind) {
        let element = null
        element = el
        if (!el) {
            element = getActiveElement()
        }
        if (!element) {
            return
        }

        if (typeof element.computed.rotate != 'undefined' && parseFloat(element.computed.rotate) !== 0) {
            element.computed.width = '750px'
            // TODO - Maybe missing original left?? review this
            element.computed.left = parseFloat(element.computed.left) + (BASE_SIZE - parseFloat(element.computed.width)) / 2 + 'px'
            delete element.computed['clip-path']
            if (element.type === 'svg' || element.content) {
                element.computed.height = 'auto'
            }
        } else {
            element.computed.height = '750px'
            // TODO - Maybe missing original top??
            element.computed.top = (BASE_SIZE - parseFloat(element.computed.height)) / 2 + 'px'
            delete element.computed['clip-path']
            if (element.type === 'svg' || element.content) {
                element.computed.width = 'auto'
            }
        }
        if (element.type === 'image' && !element.content) {
            element.computed['background-size'] = 'cover'
        }

        if (element.content) {
            let parser = new DOMParser();
            let svgDoc = parser.parseFromString(element.content, 'image/svg+xml');
            let svgElement = svgDoc.querySelector('svg');
            if (svgElement) {
                svgElement.setAttribute('preserveAspectRatio', 'none');
                svgElement.setAttribute('width', '100%');
                svgElement.setAttribute('height', '100%');
                element.content = new XMLSerializer().serializeToString(svgElement);
            }
        }
        $scope.render()
    }

    $scope.smartResponsive = function() {
        // If image is in main elements, need to make it full screen
        // If there is svg in background (or clippath), need to make it full screen
        let mainElements = getMainElements($scope.layout.tree)
        let bgElements = $scope.layout.tree.elements[INDEX_BG].elements
        for (let element of mainElements) {
            let isFullScreen = element.width == '100%' && element.height == '100%'
            let hasPosition = parseFloat(element.computed.left) != 0 || parseFloat(element.computed.top) != 0
            let isLarge = parseFloat(element.computed.width) >= BASE_SIZE && parseFloat(element.computed.height) >= BASE_SIZE
            if (!isFullScreen && !isLarge) {
                continue
            }
            if (hasPosition) {
                continue
            }
            if (element.type === 'image' && element.src) {
                $scope.makeFullHeightForeground(element)
            } else if (element.type === 'svg' || element.content) {
                $scope.makeFullHeightForeground( element)
            }
        }
        for (let element of bgElements) {
            if (element.type === 'image' && element.src) {
                $scope.makeBackgroundFullScreen(element)
            } else if (element.type === 'svg' || element.content) {
                $scope.makeFullScreen('fullscreen', element)
            }
        }
        $scope.render()
    }

    $scope.makeBackgroundFullScreen = function() {
        for (element of $scope.layout.tree.elements[INDEX_BG].elements) {
            if (element.type == 'image' && element.src) {
                element.computed['background-size'] = 'cover'
                element.computed['background-position'] = 'center'
            } else if (element.type == 'rect' || element.type == 'svg') {
                $scope.makeFullScreen('fullscreen', element)
            }
        }
        $scope.render();
    }

    $scope.makeFullHeightProportional = function() {
        $scope.moveToBackground()
        let element = getActiveElement()
        if (!element) {
            return
        }

        let aspectRatio = parseFloat(element.computed.width) / parseFloat(element.computed.height)

        element.computed.width = 'auto'
        element.computed['aspect-ratio'] = aspectRatio
        element.computed.height = '100%'
        $scope.render()
    }

    $scope.breakList = function(bgColor, iconColor, style) {
        let mainElementsMap = getMainElementsMap($scope.layout.tree)

        // find ones where replace starts with list_item
        let listItems = []
        for (let key in mainElementsMap) {
            let el = mainElementsMap[key]
            if (el.replace && el.replace.startsWith('list_icon')) {
                listItems.push(el)
            }
        }
        for (let element of listItems) {
            let left = element.computed.left
            let top = element.computed.top
            let width = element.computed.width
            let height = element.computed.height

            let newBgEl = {
                pId: element.pId,
                type: 'rect',
                group: 'list_item_' + parseInt(element.replace.replace('list_icon_', '')),
                computed: {
                    position: 'absolute',
                    left: left,
                    top: top,
                    width: width,
                    height: height,
                    'background': bgColor || '#000000',
                    'border-radius': parseFloat(width) / 2 + 'px',
                }
            }
            let iconEl = {
                pId: getNextPaintId(),
                type: 'fa',
                replace: element.replace,
                computed: {
                    position: 'absolute',
                    value: 'mdi-check',
                    left: left,
                    top: top,
                    width: width,
                    height: height,
                    color: iconColor || '#FFFFFF',
                    'font-size': (parseFloat(width) * 1.25) + 'px',
                    'display': 'flex',
                    'align-items': 'center',
                    'justify-content': 'center',
                    'text-align': 'center',
                }
            }
            // Delete all keys from original element
            for (let key in element) {
                delete element[key]
            }

            // Update element with newBgEl keys
            for (let key in newBgEl) {
                element[key] = newBgEl[key]
            }

            $scope.layout.tree.elements[INDEX_MAIN_ELEMENTS].elements.push(iconEl)
        }
    }

    $scope.alignHorizontal = function(type) {
        let element = getActiveElement()
        if (!element) {
            return
        }

        if (type === 'left') {
            delete element.computed.right
            element.computed.left = '0px'
        } else if (type === 'right') {
            delete element.computed.left
            element.computed.right = '0px'
        } else {
            delete element.computed.left
            delete element.computed.right
            let width = parseFloat(element.computed.width)
            let left = (BASE_SIZE - width) / 2
            element.computed.left = left + 'px'
        }
        $scope.refresh()
    }

    $scope.alignVertical = function(type) {
        console.log('Aligning vertical', type)
        let element = getActiveElement()
        if (!element) {
            return
        }

        if (type === 'top') {
            delete element.computed.bottom
            element.computed.top = '0px'
        } else if (type === 'bottom') {
            delete element.computed.top
            element.computed.bottom = '0px'
        } else {
            delete element.computed.top
            delete element.computed.bottom
            let height = parseFloat(element.computed.height)
            let top = (BASE_SIZE - height) / 2
            element.computed.top = top + 'px'
        }
        $scope.refresh()
    }

    $scope.alignTextVertical = function(type) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        element.computed.display = 'flex'
        if (type === 'top') {
            element.computed['align-items'] = 'flex-start'
        } else if (type === 'bottom') {
            element.computed['align-items'] = 'flex-end'
        } else if (type === 'center') {
            element.computed['align-items'] = 'center'
        }
        $scope.refresh()
    }

    $scope.alignFlexHorizontal = function(type) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        element.computed.display = 'flex'
        if (type === 'left') {
            element.computed['justify-content'] = 'flex-start'
        } else if (type === 'right') {
            element.computed['justify-content'] = 'flex-end'
        } else if (type === 'center') {
            element.computed['justify-content'] = 'center'
        }
        $scope.refresh()
    }

    $scope.alignTextHorizontal = function(type) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        if (type === 'left') {
            element.computed['text-align'] = 'left'
        } else if (type === 'right') {
            element.computed['text-align'] = 'right'
        } else if (type === 'center') {
            element.computed['text-align'] = 'center'
        }
        $scope.refresh()
    }

    $scope.hasProperty = function(property) {
        let element = getActiveElement()
        if (!element) {
            return false
        }
        return property in element.computed
    }

    $scope.deselectObject = function() {
        $scope.view.selectedLayer = null
        visualService.deselectElement()
        $scope.refresh()
    }

    $scope.previewLayout = function() {
        $scope.view.currentContent = JSON.parse(JSON.stringify(SAMPLE_CONTENT))
        // Delete fields if enabled fields are false
        let listItems = ''
        let listIndex = 1
        for (let key in $scope.view.enabledFields) {
            if (!$scope.view.enabledFields[key]) {
                delete $scope.view.currentContent[key]
            }
            if (key.startsWith('list_item') && $scope.view.enabledFields[key]) {
                listItems += `· Item ${listIndex}\n`
                listIndex += 1
            }
        }
        if (listItems) {
            $scope.view.currentContent['description'] += '\n' + listItems
        }
        if ($scope.view.currentMutatedContent) {
            $scope.view.currentContent.mutant = $scope.view.currentMutatedContent
        }
        if (!$scope.view.theme.global) {
            $scope.view.theme.global = {}
        }
        $scope.render()
    }

    $scope.onGroupChange = function() {
        let currentGroups = $scope.view.enabledGroups
        let groups = new Set()
        function findGroups(elements) {
            for (let element of elements) {
                if (element.group) {
                    groups.add(element.group)
                }
                if (element.elements) {
                    findGroups(element.elements)
                }
            }
        }
        findGroups($scope.layout.tree.elements)
        $scope.view.enabledGroups = Array.from(groups)

        // For new groups, set enabledFields to true
        for (let group of $scope.view.enabledGroups) {
            if (!(group in currentGroups)) {
                $scope.view.enabledFields[group] = true
            }
        }
        $scope.previewLayout()
    }

    $scope.previewContent = function() {
        let elementsMap = {}
        let context = $scope.view.generateContext
        let mainElements = $scope.layout.tree.elements[INDEX_MAIN_ELEMENTS].elements
        for (let element of mainElements) {
            if (element.type === 'p' || element.type === 'h1' || element.type === 'span') {
                elementsMap[element.pId] = element
            }
        }
        let elements = JSON.parse(JSON.stringify($scope.layout?.structure?.elements))
        let indexVariable = 0
        const mapColorVariable = {}
        for (var key in elements) {
            var value = elements[key];

            value = value.replace(/color\s*:\s*([^;'"]+)\s*;?/gi, function (match, color) {
                color = color.trim();

                if (color === 'inherit' || color === 'currentColor') {
                    return match;
                }

                if (!mapColorVariable[color]) {
                    mapColorVariable[color] = `$COLOR_${indexVariable++}`;
                }

                return 'color: ' + mapColorVariable[color] + ';';
            });

            elements[key] = value;
        }

        // Ignore fixed elements
        for (let key in elements) {
            if ($scope.layout.structure?.generation?.[key] === 'fixed') {
                delete elements[key]
            }
        }

        $scope.view.loading = true
        api.mutatorGenerate({
            structure: $scope.layout?.structure?.text,
            elements: elements,
            context: context,
        }).then(function(response) {
            let updatedValues = response.data.updated
            if (UPDATE_CONTENT_INLINE) {
                for (let key in updatedValues) {
                    if (elementsMap[key]) {
                        elementsMap[key].value = updatedValues[key]
                        // Replace back the color variables
                        elementsMap[key].value = elementsMap[key].value.replace(/\$COLOR_(\d+)/g, function(match, index) {
                            let color = Object.keys(mapColorVariable)[index]
                            return color ? color : match;
                        });
                    }
                }
            } else {
                $scope.view.currentMutatedContent = updatedValues
                $scope.view.currentContent = $scope.view.currentContent || {}
                $scope.view.currentContent.mutant = $scope.view.currentMutatedContent

            }
        })
        .finally(function() {
            $timeout(function() {
                $scope.render()
                $scope.view.loading = false
            })
        })
    }

    $scope.addText = function() {
        // TODO - Find it
        const contentContainerIndex = 2
        let fontFamily = ''

        function getFontFamily(kind) {
            for (let key in $scope.view.mappingKinds) {
                if ($scope.view.mappingKinds[key] === kind) {
                    let element = findElementsById($scope.layout.tree, key)
                    if (element && element.computed['font-family']) {
                        return element.computed['font-family']
                    }
                }
            }
            return null
        }
        // Try description, title, fixed_text
        fontFamily = getFontFamily('description')
        if (!fontFamily) {
            fontFamily = getFontFamily('title')
        }
        if (!fontFamily) {
            fontFamily = getFontFamily('fixed_text')
        }

        let newElement = {
            // TODO
            id: 'p-' + Math.random().toString(36).substr(2, 5),
            type: 'p',
            value: '@profile',
            computed: {
                'font-family': fontFamily,
                position: 'absolute',
                width: '100px',
                height: '15px',
                left: '0px',
                top: '0px',
                'font-size': '12px',
                'line-height': '12px',
                'text-align': 'left',
            }
        }
        $scope.layout.tree.elements[contentContainerIndex].elements.push(newElement)
        $scope.onInputsChange()
        $scope.selectLayerById(newElement.id)
    }

    $scope.onLayerChange = function(layer) {
        console.log('Layer change', layer)
    }

})